import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  UpdateSeasonInput,
  VideoSeasonProps,
} from "../store/actionType";
import { CreateSeasonForm } from "modules/video/components/CreateFolderForm";
import { updateVideoSeason } from "../store/action";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";

interface EditSeasonProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  seasonData: VideoSeasonProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & EditSeasonProps;

const EditSeason: React.FC<Props> = ({
  closeModal,
  seasonData,
  onSeasonUpdate,
}) => {
  const [loading, setLoading] = useState(false);
  const [title, settitle] = useState(seasonData.title);
  const [error, setError] = useState<string | null>(null);
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const videoSeasonsState = useSelector(
    (state: any) => state.videoSeasons.videoSeasonsState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    settitle(e.target.value);
    setError(null);
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: UpdateSeasonInput = {
      title: title,
      folder_id: seasonData.folder_id.toString(),
      season_id: seasonData.id.toString(),
    };
    if (title.trim() === "") {
      setError("Season name is required");
      return;
    } else {
      setLoading(true);
      onSeasonUpdate(input);
      setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!videoSeasonsState.isLoading && submitted) {
      if (videoSeasonsState.error) {
        setApiError(videoSeasonsState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [videoSeasonsState.isLoading, videoSeasonsState.error, submitted, closeModal]);
  return (
    <>
      <CreateSeasonForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        title={title}
        titleError={error}
        loading={loading}
        header={"Create Season"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onSeasonUpdate: (input: UpdateSeasonInput) =>
    dispatch(updateVideoSeason(input)),
});
export default connect(null, mapDispatchToProps)(EditSeason);
